module.exports = __webpack_public_path__ + "img/play.f84f0bce.png";